import {useEngagementId} from '../../../../util/customHooks';
import PropTypes from 'prop-types';
import React, {useCallback, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {labels, currentResource} from '../../../../util/utils';
import Loader from '../../LoadingIndicator/LoadingIndicator';
import Modal from '../../Modal/Modal';
import {getAccountById, getAssertionsRelatedToAccount} from '../../../../selectors/Ares/selectors';
import {updateAccount} from '../../../../actions/Account/accountactions';
import {AccountType} from '../../../../util/uiconstants';

const ChangeAccountDesignationModal = ({accountId, _accountTypeId, accountTypeName, setShow}) => {
	const dispatch = useDispatch();

	const engagementId = useEngagementId();

	const [isLoading, setIsLoading] = useState(false);

	const {accountName, statementTypeId, hasEstimate, pspIndexes, assertions: assertionIds} = useSelector(
		(state) => getAccountById(state, accountId),
		shallowEqual
	);
	const assertions = useSelector((state) => getAssertionsRelatedToAccount(state, assertionIds));
	const handleOnOkClick = useCallback(() => {
		if (_accountTypeId !== AccountType.Significant) {
			setIsLoading(true);

			dispatch(
				updateAccount(engagementId, accountId, {
					accountName: accountName,
					accountType: _accountTypeId,
					statementType: statementTypeId,
					hasEstimate: hasEstimate,
					assertionTypes:
						_accountTypeId !== AccountType.Significant
							? []
							: assertions?.map((assertion) => assertion.knowledgeAssertionId),
					PSPIndexIds: pspIndexes.map((item) => item.knowledgeContentID)
				})
			)
				.then(() => {
					setShow(false);
				})
				.finally(() => {
					setIsLoading(false);
				});
		} else {
			setShow(false);
		}
	}, [dispatch, engagementId, accountId, accountName, hasEstimate, statementTypeId, pspIndexes, assertions]);

	return (
		<Modal
			closeBtnTitle={labels.modalCancelTitle}
			closeTitle={labels.cancelButtonLabel}
			confirmBtnTitle={labels.continue}
			isCancelButtonDisabled={isLoading}
			isOkButtonDisabled={isLoading}
			modalContainerClass="changedesignation-modal"
			modalsize="small"
			onHide={() => {
				setShow(false);
			}}
			onOkClick={handleOnOkClick}
			show
			showButtons
			title={labels.changeDesignationTitle}
		>
			<Loader show={isLoading} />
			<PopupContent>
				<span>{labels.changeDesignationMessage} </span>
				<span className="account-name">{accountName} </span>
				<span>{currentResource.reviewNoteLabels.toLabel} </span>
				<span>{accountTypeName} </span>
			</PopupContent>
		</Modal>
	);
};

ChangeAccountDesignationModal.propTypes = {
	accountId: PropTypes.number.isRequired,
	_accountTypeId: PropTypes.number.isRequired,
	accountTypeName: PropTypes.string.isRequired,
	setShow: PropTypes.func.isRequired
};

export default ChangeAccountDesignationModal;

const PopupContent = styled.section`
	font-size: var(--px-12);
	margin: var(--px-30) var(--px-20);
	.account-name {
		font-weight: bold;
	}
`;
